<template>
    <div class="border_bottom">
        <div class="header mb-6">
            <vs-button color="dark" type="flat" icon-pack="feather" icon="icon-arrow-left" class="p-0"
                @click="goBack()"></vs-button>
            <div class="w-1/2 justify-right">
                <h2 class="pl-2">{{ editRoute ? $t('labels.edit_organization') : $t('labels.add_organization') }}</h2>
            </div>
        </div>
        <div class="addedit-organization center">
            <form @submit.prevent="checkValidation()" autocomplete="off">
                <vx-card class="addedit-organization-card">
                    <div class="vx-row w-full m-0">
                        <div class="vx-col sm:w-full mb-4 p-0">
                            <label>{{ $t('labels.name') }}</label>
                            <vs-input type="text" class="w-full mt-1" name="organization_name" maxlength="250"
                                v-model="name" icon-no-border :placeholder="$t('labels.organization_name')"
                                v-validate="'required'" />
                            <span class="text-danger text-sm">{{ errors.first('organization_name') }}</span>
                        </div>
                    </div>
                    <div class="mt-2 btn-lead flex justify-center">
                        <vs-button
                            class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
                            :disabled="button_loading" id="create-organization" button="submit">{{ editRoute ?
                                $t('labels.update_organization') : $t('labels.add_organization') }}</vs-button>
                    </div>
                </vx-card>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            button_loading: false,
        };
    },
    computed: {
        editRoute() {
            return this.$route.params.id || false;
        }
    },
    mounted() {
        this.setValidationMessage();
        if (this.editRoute) {
            this.getOrganization();
        }
    },
    methods: {
        checkValidation() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.createUpdateOrganization();
                }
            });
        },
        async createUpdateOrganization() {
            this.button_loading = true;
            try {
                const input = { name: this.name };
                const url = this.editRoute
                    ? "/organizations/update/" + this.editRoute
                    : "/organizations/create";
                const response = await this.getHTTPPostResponse(
                    url,
                    input,
                    "#create-organization",
                    true
                );
                if (response) {
                    this.$router.push({ name: "OrganizationList" });
                }
            } catch (error) {
                console.error("Organization submission failed", error);
            } finally {
                this.button_loading = false;
            }
        },
        async getOrganization() {
            try {
                const response = await this.getHTTPGetResponse("/organizations/get/" + this.editRoute);
                if (response) {
                    this.name = response.data.organization.name;
                }
            } catch (error) {
                console.error("Failed to fetch organization", error);
            }
        },
        goBack() {
            history.back();
        }
    }
};
</script>